export default __webpack_public_path__ + "static/media/gingerwhole.fa21f8e9.jpg";